// The running app version. Bump this to match the release marker on every deploy
// ("merge and deploy as vX.X.X.X"): the worker records a "release.published" row in the audit log the
// first time it serves a version it has not recorded before, and the Audit page shows the current one.
export const APP_VERSION = '2.0.19.61';
//# sourceMappingURL=version.js.map